// @flow
import { RouteNames } from 'router';
import { StringUtil } from 'utils/StringUtil';

// TODO:
const getRouteForVertical = (verticalName: string): string => {
  let name = verticalName.split(' ').join('');
  name = StringUtil.lowerCaseString(name);

  const searchVertical = vertical => {
    if (name.includes(vertical)) {
      name = '/' + vertical;
      return name.includes(vertical);
    }
  };

  if (name.includes('shibanee')) {
    return RouteNames.architectureDesign;
  }

  if (name.includes('music')) {
    return RouteNames.musicEvents;
  }

  if (name.includes('land-craft')) {
    return RouteNames.landCraft;
  }

  switch (name) {
    case searchVertical('homes'):
      return RouteNames.homes;
    case searchVertical('restaurants'):
      return RouteNames.restaurants;
    case searchVertical('store'):
      return RouteNames.store;
    case searchVertical('rentals'):
      return RouteNames.rentals;
    case searchVertical('workcations'):
      return RouteNames.workcations;
    case searchVertical('resorts'):
      return RouteNames.resorts;
    case searchVertical('land-Craft'):
      return RouteNames.landCraft;
    default:
      break;
  }

  return name;
};

const getVerticalKeyForLocation = (location: any): string => {
  const pathName = (location.pathname || '').replace('/', '').split('#')[0];
  const pathItems = pathName.split('/');
  return pathItems.length > 0 ? pathItems[0] : null;
};

export const NavigationUtil = {
  getRouteForVertical,
  getVerticalKeyForLocation,
};
